/**
 * Tooltip component
 * Displays helpful information on hover
 */

import { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { cn } from '@/utils/classNames';

interface TooltipProps {
  content: string;
  className?: string;
}

export function Tooltip({ content, className }: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onFocus={() => setIsVisible(true)}
        onBlur={() => setIsVisible(false)}
        className={cn(
          'text-text-tertiary hover:text-text-secondary',
          'transition-colors cursor-help',
          className
        )}
        aria-label="Help information"
      >
        <HelpCircle className="h-4 w-4" />
      </button>

      {isVisible && (
        <div
          className={cn(
            'absolute z-50 w-64 px-3 py-2',
            'bg-bg-inverse text-text-inverse text-sm rounded-lg shadow-lg',
            'left-6 top-0',
            'pointer-events-none'
          )}
          role="tooltip"
        >
          <div className="relative">
            {/* Arrow */}
            <div
              className="absolute -left-4 top-1 w-0 h-0"
              style={{
                borderTop: '6px solid transparent',
                borderBottom: '6px solid transparent',
                borderRight: '6px solid #111827',
              }}
            />
            {content}
          </div>
        </div>
      )}
    </div>
  );
}
